@if (!emptyTableCheck()) {
  <table
    mat-table
    [dataSource]="dataSource"
    multiTemplateDataRows
    class="task-table"
  >
    <!-- Expansion Column -->
    <ng-container matColumnDef="expand">
      <th mat-header-cell *matHeaderCellDef aria-label="row actions">&nbsp;</th>
      <td mat-cell *matCellDef="let element">
        <button
          mat-icon-button
          aria-label="expand row"
          class="expand-btn"
          (click)="
            expandedElement = expandedElement === element ? null : element;
            $event.stopPropagation()
          "
        >
          @if (expandedElement === element) {
            <mat-icon>keyboard_arrow_up</mat-icon>
          } @else {
            <mat-icon>keyboard_arrow_down</mat-icon>
          }
        </button>
      </td>
    </ng-container>

    @for (column of columnsToDisplay; track column) {
      <!-- Name Column -->
      @if (column === 'Open Defects') {
        <ng-container matColumnDef="Open Defects">
          <th mat-header-cell *matHeaderCellDef class="name-column">
            <div class="checklist-header-style">
              {{ openDefects }}
              <mat-icon (click)="showText = !showText" style="margin-right: 5px"
                >read_more</mat-icon
              >
            </div>
          </th>
          <td mat-cell *matCellDef="let element" style="max-width: 12px">
            <div class="defect-text">
              @if (showText) {
                <div class="checklist-name">{{ element.TaskName }}</div>
              } @else {
                <div class="checklist-name-collapsed">
                  {{ element.TaskName }}
                </div>
              }
              <div class="name-location">
                ({{ populateLocations(element.LocationId) }})
              </div>
            </div>
          </td>
        </ng-container>
      } @else if (column === 'Designate') {
        <!-- Designate Column -->
        <ng-container matColumnDef="Designate">
          <th mat-header-cell *matHeaderCellDef class="action-column">
            {{ designate }}
          </th>
          <td mat-cell *matCellDef="let element">
            @if (disabledCheck(element)) {
              <!-- hide the designate to station button because the defect is fixed -->
            } @else {
              <div class="designate-container">
                @if (stationEqual(element)) {
                  <button
                    mat-icon-button
                    aria-label="expand row"
                    class="designate-station-btn"
                    (click)="sendToStation(element)"
                  >
                    {{ sendToStationText }}
                  </button>
                } @else {
                  <button
                    mat-icon-button
                    aria-label="expand row"
                    class="designate-station-btn-disabled"
                    disabled
                  >
                    {{ sendToStationText }}
                  </button>
                }
              </div>
            }
          </td>
        </ng-container>
      } @else if (column === 'Fixed') {
        <!-- Fixed Column -->
        <ng-container matColumnDef="Fixed">
          <th mat-header-cell *matHeaderCellDef class="action-column">
            {{ fixed }}
          </th>
          <td mat-cell *matCellDef="let element">
            @if (stationEqual(element)) {
              <div class="designate-container">
                <mat-checkbox
                  class="fix-chkbox"
                  [checked]="element.StatusId === 3"
                  [disabled]="element.StatusId === 3"
                  (change)="onCheckboxChange($event, element)"
                ></mat-checkbox>
              </div>
            }
            @if (element.StationId === null) {
              <b style="color: var(--qbuilt-green)">{{ fixed }}</b>
            } @else {
              <!-- Hide the fixed button because the station has been designated -->
            }
          </td>
        </ng-container>
      }
    }

    <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
    <ng-container matColumnDef="expandedDetail">
      <td
        mat-cell
        *matCellDef="let element"
        [attr.colspan]="columnsToDisplayWithExpand.length"
      >
        <div
          class="element-detail"
          [@detailExpand]="
            element == expandedElement ? 'expanded' : 'collapsed'
          "
        >
          <div class="detail-row">
            <span class="detail-label">Location:</span>
            <span class="">{{ populateLocations(element.LocationId) }}</span>
          </div>
          <div class="detail-row">
            <span class="detail-label">Defect Quantity:</span>
            <span class="">{{ element.DefectQuantity }}</span>
          </div>
          @if (element.Description) {
            <div class="detail-row">
              <span class="detail-label">Defect Details:</span>
              <span class="">{{ element.Description }}</span>
            </div>
          }
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columnsToDisplayWithExpand"></tr>
    <tr
      mat-row
      *matRowDef="let element; columns: columnsToDisplayWithExpand"
      class="example-element-row"
      [class.example-expanded-row]="expandedElement === element"
      (click)="onExpandElement(element)"
    ></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: ['expandedDetail']"
      class="example-detail-row"
    ></tr>
  </table>
}
